import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  MessageCircle,
  X,
  Phone,
  Instagram,
  Facebook,
  Twitter,
  Youtube,
  Mail,
  MapPin,
  Tikto
} from 'lucide-react';
import { FaTiktok } from "react-icons/fa";

import './FloatingSocial.css';

const socialLinks = [
  {
    name: 'واتساب الحجز',
    icon: MessageCircle,
    color: '#25D366',
    url: 'https://wa.me/201126276505',
    bg: 'rgba(37, 211, 102, 0.15)'
  },
  {
    name: 'تيك توك',
    icon: FaTiktok,
    color: '#ffffff',
    url: 'https://www.tiktok.com/@dr.mohamed.khaled.t',
    bg: 'rgb(0, 0, 0)'
  },
  {
    name: 'فيسبوك',
    icon: Facebook,
    color: '#1877F2',
    url: 'https://www.facebook.com/share/1DGkN6yJi7/',
    bg: 'rgba(24, 119, 242, 0.15)'
  },
  {
    name: 'طوارئ',
    icon: Phone,
    color: '#c9a84c',
    url: 'tel:+201289444600',
    bg: 'rgba(201, 168, 76, 0.15)'
  }
];

const FloatingSocial = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="floating-social">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ duration: 0.3 }}
            className="social-menu"
          >
            <div className="social-menu-header">
              <h4>تواصل معنا</h4>
              <p>اختر الطريقة المناسبة</p>
            </div>
            <div className="social-links-grid">
              {socialLinks.map((link, index) => (
                <motion.a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                  className="social-link-item"
                  style={{ '--social-color': link.color, '--social-bg': link.bg }}
                  whileHover={{ scale: 1.05, x: -5 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <div className="social-icon-wrapper">
                    <link.icon size={20} />
                  </div>
                  <span className="social-name">{link.name}</span>
                </motion.a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        className={`fab-button ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        animate={isOpen ? { rotate: 180 } : { rotate: 0 }}
        transition={{ duration: 0.3 }}
      >
        {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
      </motion.button>
    </div>
  );
};

export default FloatingSocial;